import React, { useEffect, useState } from "react";
import { fetchTasks } from "../../api/api";

const TaskList = ({ project_id, refresh }) => {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (!project_id) return;

    const loadTasks = async () => {
      try {
        const data = await fetchTasks(project_id);
        // Make sure tasks array exists
        setTasks(data.tasks || []);
      } catch (err) {
        console.error(err);
      }
    };

    loadTasks();
  }, [project_id, refresh]);

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Tasks</h5>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Description</th>
              <th>Status</th>
              <th>Priority</th>
              <th>Assigned To</th>
            </tr>
          </thead>
          <tbody>
            {tasks.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center text-muted">
                  No tasks found
                </td>
              </tr>
            ) : (
              tasks.map((t) => (
                <tr key={t.id}>
                  <td>{t.description}</td>
                  <td>{t.status}</td>
                  <td>{t.priority}</td>
                  <td>{t.assigned_to_name || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TaskList;
